import StatCard from '../../components/common/StatCard';
import Button from '../../components/common/Button';
import './LazyMarketing.css';

const Social = () => {
  const stats = [
    { label: 'Followers', value: '125K', change: '+8.2K', changeType: 'positive' },
    { label: 'Posts', value: '156', change: '+24', changeType: 'positive' },
    { label: 'Engagement', value: '4.8%', change: '+0.6%', changeType: 'positive' },
    { label: 'Reach', value: '2.1M', change: '+340K', changeType: 'positive' },
  ];

  const platforms = [
    { name: 'LinkedIn', followers: '45K', engagement: '5.2%', status: 'Connected' },
    { name: 'Twitter/X', followers: '38K', engagement: '3.8%', status: 'Connected' },
    { name: 'Instagram', followers: '28K', engagement: '6.4%', status: 'Connected' },
    { name: 'Facebook', followers: '14K', engagement: '2.1%', status: 'Connected' },
  ];

  return (
    <div className="lm-page">
      <div className="lm-page-header">
        <h1 className="lm-page-title">Social Media</h1>
        <p className="lm-page-subtitle">Manage social media presence</p>
      </div>

      <div className="lm-stats-row">
        {stats.map((stat, index) => (
          <StatCard key={index} {...stat} />
        ))}
      </div>

      <div className="lm-section">
        <div className="lm-section-header">
          <h3 className="lm-section-title">Connected Platforms</h3>
          <Button variant="primary" size="sm" icon="plus">Connect Platform</Button>
        </div>
        <div className="lm-grid">
          {platforms.map((platform, index) => (
            <div key={index} className="lm-grid-card">
              <div className="lm-grid-card-header">
                <span className="lm-grid-card-title">{platform.name}</span>
                <span className="lm-grid-card-badge" style={{
                  background: 'var(--success-soft)',
                  color: 'var(--success)'
                }}>{platform.status}</span>
              </div>
              <div className="lm-grid-card-content">
                <p>{platform.followers} followers • {platform.engagement} engagement</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Social;
